import { render } from "./TomaPedidos.vue?vue&type=template&id=a1de970a"
import script from "./TomaPedidos.vue?vue&type=script&lang=js"
export * from "./TomaPedidos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__